import type { AuthStore } from '@stores/auth/interfaces'

export const getters = {
  isLoading: (state: AuthStore): AuthStore['loading'] => state.loading,
  isAuthenticated: (state: AuthStore): boolean => !!state.accessToken,
  secondsLeft: (state: AuthStore) => (): number => Math.max(0, Math.floor((state.expiresAt - Date.now()) / 1000)),
  isExpired: (state: AuthStore) => (): boolean => state.expiresAt !== 0 && Date.now() >= state.expiresAt,
  isRemember: (state: AuthStore): AuthStore['remember'] => state.remember,
  getEmail: (state: AuthStore): AuthStore['email'] => state.email,
  getPassword: (state: AuthStore): AuthStore['password'] => state.password,
  getErrorEmail: (state: AuthStore): AuthStore['errorEmail'] => state.errorEmail,
  getErrorPassword: (state: AuthStore): AuthStore['errorPassword'] => state.errorPassword,
}
